var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-automotive",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "car-01",
    transform: "translate(2.735 3.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M17.919,19.773c-.2,0-.3,0-.358.061s-.061.16-.061.358V20.7a1.042,1.042,0,0,0,.652.937l.047.021a1.827,1.827,0,0,0,.758.213h1.8a1.827,1.827,0,0,0,.758-.213l.047-.021a1.043,1.043,0,0,0,.652-.937v-.931c0-.268,0-.4-.074-.464s-.223-.038-.521.01l-.09.013-3.266.432a1.828,1.828,0,0,1-.241.016Z",
    transform: "translate(-0.474 -1.438)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M6.3,19.773c.2,0,.3,0,.358.061s.061.16.061.358V20.7a1.043,1.043,0,0,1-.652.937l-.047.021a1.827,1.827,0,0,1-.758.213h-1.8a1.827,1.827,0,0,1-.758-.213l-.047-.021A1.043,1.043,0,0,1,2,20.7v-.931c0-.268,0-.4.074-.464s.223-.038.521.01l.09.013,3.266.432a1.83,1.83,0,0,0,.241.016Z",
    transform: "translate(-1.214 -1.438)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M2.111,7.579a1.048,1.048,0,0,1,1.406-.469l1.048.524a1.048,1.048,0,0,1-.937,1.874L2.579,8.985A1.048,1.048,0,0,1,2.111,7.579Zm20.734,0a1.048,1.048,0,0,1-.469,1.406l-1.048.524a1.048,1.048,0,0,1-.937-1.874l1.048-.524A1.048,1.048,0,0,1,22.845,7.579Z",
    transform: "translate(-1.214 -2.023)",
    fill: "#222227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M21.255,9.108a17.317,17.317,0,0,1,1.432,1.619,4.752,4.752,0,0,1,1.09,2.786v3.636a1.923,1.923,0,0,1-1.608,1.95l-3.266.432a.788.788,0,0,1-.1.007H6.227a.789.789,0,0,1-.1-.007L2.858,19.1a1.923,1.923,0,0,1-1.608-1.95V13.513a4.753,4.753,0,0,1,1.09-2.786A17.306,17.306,0,0,1,3.771,9.108a.667.667,0,0,0,.15-.293L5.045,5.559A15.357,15.357,0,0,1,5.641,4,2.927,2.927,0,0,1,6.6,2.806a3.083,3.083,0,0,1,1.476-.5A16.823,16.823,0,0,1,9.8,2.25h5.429a16.821,16.821,0,0,1,1.72.053,3.083,3.083,0,0,1,1.476.5A2.928,2.928,0,0,1,19.385,4a15.366,15.366,0,0,1,.6,1.56L21.1,8.815A.705.705,0,0,0,21.255,9.108ZM7.044,8.537c-.4,0-.6,0-.7-.132s-.028-.322.1-.7l.508-1.473a14.477,14.477,0,0,1,.527-1.4.878.878,0,0,1,.824-.574c.349-.039.812-.04,1.543-.04h5.322c.731,0,1.194,0,1.543.04a.878.878,0,0,1,.824.574,14.461,14.461,0,0,1,.527,1.4L18.577,7.7c.131.38.2.57.1.7s-.3.132-.7.132ZM3.435,12.025a.786.786,0,0,0-.7,1.406l1.572.786a.786.786,0,0,0,.7-1.406Zm18.86,1.406a.786.786,0,0,0-.7-1.406l-1.572.786a.786.786,0,1,0,.7,1.406Zm-8.766,2.178H11.5c-1.031,0-1.546,0-1.945.287a2.5,2.5,0,0,0-.741,1.2c-.108.273-.162.41-.1.509s.2.1.486.1h6.629c.283,0,.424,0,.486-.1s.008-.236-.1-.509a2.5,2.5,0,0,0-.741-1.2C15.075,15.609,14.56,15.609,13.529,15.609Z",
    transform: "translate(-1.25 -2.25)",
    fill: "#222227",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCar);
export default __webpack_public_path__ + "static/media/icon-car.d631162e7e943f3cbf66a46ef3797ef6.svg";
export { ForwardRef as ReactComponent };